<template>
	<div class="parent-page">
		<div class="parent-page__banner">
			<img :src="bannerImg" alt="" />
		</div>

		<div class="parent-page__left-right">
			<div class="parent-page__breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
					<el-breadcrumb-item
						v-for="route in $route.matched"
						:key="route.path"
						:to="route.path"
					>
						{{ route.meta.title }}
					</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="left-right__main">
				<div class="left-right__left">
					<LeftNav :currentModule="currentModule" />
				</div>
				<div class="left-right__right">
					<router-view :key="$route.fullPath"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LeftNav from './LeftNav.vue'
export default {
	props: {},
	data() {
		return {}
	},
	inject: ['navList'],
	computed: {
		currentModule() {
			return this.navList.find(
				(nav) => this.$route.matched[0].path === nav.path
			)
		},
		bannerImg() {
			return {
				ProjectInvestment: require('@/assets/images/banner/banner1.png'),
				ParkDynamics: require('@/assets/images/banner/banner2.png'),
				HatchingService: require('@/assets/images/banner/banner3.png'),
				PartyBuilding: require('@/assets/images/banner/banner4.png'),
				ParkProfile: require('@/assets/images/banner/banner5.png'),
			}[this.currentModule.name]
		},
	},
	components: {
		LeftNav,
	},
	created() {},
	mounted() {},
	watch: {},
	methods: {},
}
</script>

<style lang="scss">
.parent-page {
	padding-bottom: 60px;
	&__banner {
		height: 280px;
		& > img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	&__breadcrumb {
		padding: 30px 0;
	}
	&__left-right {
		width: 1200px;
		margin: 0 auto;
	}
}
.left-right {
	&__main {
		display: flex;
	}
	&__left {
		background-color: #ffffff;
		flex-shrink: 0;
	}
	&__right {
		background-color: #ffffff;
		margin-left: 30px;
		flex: 1;
		width: 0;
	}
}
</style>
